import React, { useState } from 'react';
import {
    MdSegment,
    MdGroups2,
    MdLocalPharmacy,
    MdWifiProtectedSetup,
    MdOutlineDashboardCustomize
} from "react-icons/md";

import { FaPrescriptionBottleAlt } from "react-icons/fa";
import { FaUser,FaUserDoctor ,FaUserNurse ,FaDesktop , FaBaby , FaCross ,FaUserGear}  from "react-icons/fa6";


const Sidebar =({setPersonnel}: any) =>{
    const [hideDetails, setHideDetails] = useState(false);

    return(
        <>
        <div className="sidebar-container">
            <div className="sidebar-icon">
                <MdSegment onClick={()=>setHideDetails(!hideDetails)}/>
            </div>
            <ul className="sidebar-ul">
                <li className='sidebarli' onClick={()=>alert('This opens up Dashboard module')}>
                    <MdOutlineDashboardCustomize />
                    <p className={hideDetails ? 'sidebarli_p' : '' } >Dashboard</p>
                </li>
                <li onClick={()=>alert('This opens up Departments module')}> 
                    <MdGroups2 />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Department</p>
                </li>
                <li onClick={()=>alert('This opens up Doctors module')}> 
                    <FaUserDoctor />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Doctor</p>
                </li>
                <li onClick={()=>alert('This opens up Patients module')}> 
                    <FaUser />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Patient</p>
                </li>
                <li onClick={()=>alert('This opens up Nurses module')}>
                    <FaUserNurse />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Nurse</p>
                </li>
                <li onClick={()=>alert('This opens up Pharmacist module')}>
                    <FaPrescriptionBottleAlt />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Pharmacist</p>
                </li>
                <li onClick={()=>setPersonnel('laboratorist')}>
                    <MdLocalPharmacy />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Laboratorist</p>
                </li>
                <li onClick={()=>alert('This opens up Receptionist module')}>
                    <FaDesktop />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Receptionist</p>
                </li>
                <li onClick={()=>alert('This opens up operation module')}>
                    <MdWifiProtectedSetup />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Operation</p>
                </li>
                <li onClick={()=>alert('This opens up Birth module')}>
                    <FaBaby />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Birth Report</p>
                </li>
                <li onClick={()=>alert('This opens up Death module')}>
                    <FaCross />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Death Report</p>
                </li>
                <li onClick={()=>alert('This opens up your profile')}>
                    <FaUserGear />
                    <p className={hideDetails ? 'sidebarli_p' : '' }>Profile</p>
                </li>
            </ul>
        </div>
        </>
    )
}

export default React.memo(Sidebar);
